import {getMaxLength, getTplOptions} from './helper';
import {intelSizeOptions, btbIndustry, normalIndustry} from './constants';

const designSizeControlParams = {
    indestryBaseSizeMap: {
        ...btbIndustry.reduce((acc, item) => {
            acc[item] = '1:1';
            return acc;
        }, {}),
        ...normalIndustry.reduce((acc, item) => {
            acc[item] = '16:9';
            return acc;
        }, {})
    },
    sizeControlOptions: function (e) {
        return getTplOptions(e);
    }
};

export const intelFormConfig = [
    {
        name: 'bgControl',
        label: '创意描述',
        placeholder: '',
        visible: true,
        type: 'textExpandArea',
        tip: '输入图片主体、背景、视角、风格等详细信息，描述越具体生成效果越好',
        hideTitle: false,
        params: {
            maxLength: 800,
            generatePlaceholder: `请尝试分别描述画面上想要出现的主体及场景
示例：小女孩在教室里学习，微笑，穿着白连衣裙，真实风格`,
            promptMatchList: [
                {
                    key: '客厅',
                    value: '宽敞的客厅，大窗户，沙发，茶几，现代，极简，深米色，灰色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '楼盘',
                    value: '高层独立建筑，黄昏，整洁，规则，灯光，现代，极简，银色和浅色靛蓝，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '卧室',
                    value: '宽敞的卧室，床，木地板，现代，极简，米色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '餐厅',
                    value: '宽敞的餐厅，大窗户，餐桌，餐椅，大理石地板，现代，极简，米色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '别墅',
                    value: '别墅客厅，双高空间，大落地窗，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '车间',
                    value: '流水线，工厂，绿色地板，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '毛坯',
                    value: '一个正在装修的空屋，建筑材料，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '办公室',
                    value: '宽敞的办公区域，几张办公桌，办公椅，电脑，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '衣帽间',
                    value: '宽敞的衣帽间，衣柜，镜子，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '厨房',
                    value: '宽敞的厨房，岛台，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '书房',
                    value: '宽敞的现代书房，大窗户，书桌，椅子，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '洗手间',
                    value: '宽敞浴室，马桶，淋浴，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '城市',
                    value: '城市天际线夜景，高楼，河，灯光，霓虹，明亮，色彩丰富，蓝紫色天空，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '山川',
                    value: '阿尔卑斯山风景，绿色草地，清澈的湖水，水面反射出山脉，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '沙滩',
                    value: '斯里兰卡美丽海滩，白色沙滩，棕榈树，海湾海滨，清澈的蓝色海水，海岸两侧绿色植物为背景，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '草原',
                    value: '云南山谷，草原风景，河流，草地。天空在阳光下泛着蓝色的光芒，田园诗般的场景，大自然，壮丽，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '海景',
                    value: '俯瞰菲律宾岛屿，海湾海滨，背景是绿松石色的海水和岩石，绿色植物，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '酒店',
                    value: '高端酒店客房，宽敞的房间，床，窗帘，大落地窗，现代，广角，明亮，真实风格，照片级，丰富细节，高质量，HD'
                },
                {
                    key: '古镇',
                    value: '徽派建筑，古镇，河，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '机场',
                    value: '航空，白色涂装，在柔和的云层上方飞行，蓝天背景，航空摄影师，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '老虎',
                    value: '动物园，老虎，草地，岩石，动物摄影，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '熊猫',
                    value: '动物园，大熊猫吃竹子，草地，动物摄影，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '海洋馆',
                    value: '水族馆，鲨鱼和鱼在游动，人们在外面观看的剪影，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '教室',
                    value: '教室，黑板，课桌，椅子，广角，明亮，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '操场',
                    value: '学校，绿色草坪，教学楼，中景，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '前台',
                    value: '美容院，大厅，前台，沙发，大理石地面，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '手术室',
                    value: '美容院，手术台，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '美容院',
                    value: '美容院，白色医美床，大理石地面，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '牙科',
                    value: '现代化的牙科办公室，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                },
                {
                    key: '走廊',
                    value: '美容院走廊，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
                }
            ]
        }
        // rules: [
        //     {
        //         required: false,
        //         validator(rule, value, formData) {
        //             const {type, value: val} = value;
        //             if (type === 'generate' && !val?.prompt) {
        //                 return Promise.reject('请输入描述为空');
        //             }
        //             if (type === 'generate' && val?.prompt && val.prompt.length > 200) {
        //                 return Promise.reject('请输入描述长度不超过200个字符');
        //             }
        //             return Promise.resolve();
        //           }
        //     }
        // ]
    },
    {
        name: 'referPic',
        label: '参考图',
        placeholder: '',
        type: 'uploadImgCard',
        tip: '学习和理解图片内容，根据参考图片和创意描述融合生成图片',
        visible: true,
        exclusiveName: 'creativeStyle',
        exclusiveLabel: '创意风格',
        canCutout: true,
        params: {
            mainTitle: '已上传的参考图',
            hideSubTitle: true,
            iconList: [
                'delete',
                'aiDesc',
                'edit',
                'add'
            ],
            tip: '参考强度越高，生成图片越接近参考图；参考强度越低，生成图片越接近创意描述',
            sliderInfo: {
                min: 1,
                max: 3,
                step: 1,
                labelMap: {
                    1: '低',
                    2: '中',
                    3: '高'
                }
            }
        }
    },
    {
        name: 'creativeStyle',
        label: '创意风格',
        placeholder: '',
        type: 'creativeStyleCard',
        visible: false,
        exclusiveName: 'referPic',
        exclusiveLabel: '参考图',
        imgTypeList: [
            {
                value: '',
                label: '全部'
            },
            {
                value: '写实',
                label: '写实'
            },
            {
                value: '3D',
                label: '3D'
            },
            {
                value: '插画',
                label: '插画'
            }
        ],
        imgStyleList: [
            {
                value: 'publicStyle',
                label: '公共风格'
            },
            {
                value: 'privateStyle',
                label: '私有风格',
                searchPlaceholder: '搜索风格名称'
            }
        ],
        params: {
            mainTitle: '已选的风格',
            hideSubTitle: true,
            hideDegreeBar: true,
            hideDelBtn: true,
            coverMode: true,
            iconList: [
                {name: 'delete', id: 'creativeStyleDelete'},
                {name: 'add', id: 'creativeStyleAdd'}
            ]
        }
    },
    // {
    //     name: 'referDegree',
    //     label: '参考强度',
    //     placeholder: '',
    //     type: 'slider',
    //     visible: false,
    //     params: {
    //         sliderInfo: {
    //             min: 1,
    //             max: 3,
    //             step: 1,
    //             labelMap: {
    //                 1: '低',
    //                 2: '中',
    //                 3: '高'
    //             }
    //         }
    //     }
    // },
    {
        name: 'sizeControl',
        label: '比例尺寸',
        placeholder: '',
        visible: true,
        type: 'sizeControl',
        hideTitle: false,
        params: {
            showType: false,
            options: intelSizeOptions
        }
    }
];

export const designFormConfig = [
    {
        name: 'templateGroup',
        label: '模板',
        placeholder: '',
        visible: true,
        type: 'templateGroup',
        params: {
            mainComponentName: '',
            templateTag: ['擎舵2.0', '不抠图'],
            showCultureOption: true,
            industryOptions: [
                {
                    value: '',
                    label: '全部行业'
                },
                {
                    value: '5',
                    label: '教育培训'
                },
                {
                    value: '19',
                    label: '文娱传媒'
                },
                {
                    value: '10',
                    label: '金融服务'
                },
                {
                    value: '8',
                    label: '生活服务'
                },
                {
                    value: '11',
                    label: '房产家居'
                },
                {
                    value: '4',
                    label: '整形美容'
                },
                {
                    value: '7',
                    label: '商务服务'
                },
                {
                    value: '17',
                    label: '旅游服务'
                },
                {
                    value: '9',
                    label: '商品交易'
                },
                {
                    value: '16',
                    label: '游戏'
                },
                {
                    value: '15',
                    label: '软件'
                },
                {
                    value: '13',
                    label: '交通出行'
                },
                {
                    value: '30',
                    label: '网络服务'
                },
                {
                    value: '14',
                    label: '机械设备'
                },
                {
                    value: '3',
                    label: '医疗服务'
                },
                {
                    value: '31',
                    label: '农林牧渔'
                },
                {
                    value: '29',
                    label: '通信'
                },
                {
                    value: '20',
                    label: '化工及能源'
                },
                {
                    value: '28',
                    label: '电子电工'
                },
                {
                    value: '34',
                    label: '直营电商'
                },
                {
                    value: '25',
                    label: '食品饮料'
                },
                {
                    value: '22',
                    label: '保健品/药品'
                }
            ],
            ratioOptions: function (e) {
                return getTplOptions(e);
            },
            ...designSizeControlParams,
            chooseMax: 6
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {template: {chooseList}} = value;
                    const {template: {chooseMyTpl}} = value;
                    if (!chooseList?.length && !chooseMyTpl?.length) {
                        return Promise.reject('请选择模板');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'mainText',
        label: '主标题',
        placeholder: '例：养生推拿公益课',
        visible: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            depends: {
                watch: 'templateGroup',
                property: 'industry.value'
            },
            sugList: {
                5: [
                    [
                        '零基础英语学习',
                        '奇妙识字教育课'
                    ],
                    [
                        '零基础学识字',
                        '零基础全新起点'
                    ],
                    [
                        '英语启蒙班',
                        '零基础学识字'
                    ],
                    [
                        '雅思寒假班开课啦',
                        '英语启蒙学习课程'
                    ],
                    [
                        '雅思寒假班报名中',
                        '打造学习的成功之路'
                    ],
                    [
                        '开启冲刺模式',
                        '精彩讲座开启'
                    ],
                    [
                        '创意大赛报名',
                        '社交技巧讲座预告'
                    ],
                    [
                        '亲子互动',
                        '轻松掌握数学'
                    ],
                    [
                        '个性化学习'
                    ]
                ]
            }
        }
    },
    {
        name: 'descText',
        label: '副标题',
        placeholder: '例：学习中医按摩手法',
        visible: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            depends: {
                watch: 'templateGroup',
                property: 'industry.value'
            },
            sugList: {
                5: [
                    [
                        '学习入门训练',
                        '基础概念解析课程'
                    ],
                    [
                        '幼升小轻松衔接',
                        '冲刺新学期'
                    ],
                    [
                        '助您迎接新学期挑战',
                        '为新学期冲刺加油'
                    ],
                    [
                        '寒假蓄能',
                        '掌握前沿知识'
                    ],
                    [
                        '火热进行中',
                        '提升社交能力'
                    ],
                    [
                        '与孩子一同探索创意',
                        '提高学习成绩'
                    ],
                    [
                        '助你成为学霸'
                    ]
                ]
            }
        }
    },
    {
        name: 'buttonText',
        label: '按钮文案',
        placeholder: '例：点击报名',
        visible: false,
        needClear: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            }
        }
    },
    {
        name: 'otherText',
        label: '其他文案',
        placeholder: '例：限时免费',
        visible: false,
        needClear: true,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            }
        }
    },
    {
        name: 'businessPointB2B',
        label: '业务点',
        layerName: '主标题',
        placeholder: '请输入投放推广的产品，例：包子机',
        tip: '业务点指客户希望在百度投放推广的产品，如包子机、挖掘机等。',
        visible: false,
        type: 'autoComplete',
        params: {
            strict: true,
            maxlength: 20,
            showRequired: true,
            model: 'imageCreate',
            method: 'getTradesB2B'
        },
        rules: [
            {
                required: true,
                message: '请输入业务点',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointFirst',
        label: '卖点1',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            index: 0,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点1',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointSecond',
        label: '卖点2',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            index: 1,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点2',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointThird',
        label: '卖点3',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            index: 2,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点3',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'manufacturerName',
        label: '厂商名称',
        layerName: '厂商名称',
        placeholder: '请输入',
        visible: false,
        needClear: true,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: 12
        }
    },
    {
        name: 'riskText',
        label: '风险提示语',
        placeholder: '请输入',
        visible: false,
        needClear: true,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: 30
        }
    },
    {
        name: 'brandLogo',
        label: '品牌LOGO',
        placeholder: '',
        type: 'uploadImgCard',
        visible: true,
        needClear: true,
        canCutout: true,
        params: {
        }
    }
];
